module.exports = __webpack_public_path__ + "static/heroes_logo_full_en-36aac6d0862723127543db7250b46bf1.svg";